/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  ErrorPage.tsx
 *
 * Project Title :  Checkout
 *
 * Description	:
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Madhu Gali
 *
 * @Date			  : Sep 30, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : Madhu Gali (H175591)
 * On            : Sep 30, 2019
 * Description   : ASDS-1419
 *
 * By            : Sandeep Raja
 * On            : Nov 15, 2019
 * Description   : ASDS-1829: Internal Server Message UI & Integration
 *
 * By            : H224423
 * On            : Feb 03 2020
 * Description   : Fixed HTML block and inline elements order issues.
 *
 * By            : H224423
 * On            : Mar 12 2020
 * Description   : Updated Verbiage
 *
 * By            : H224423
 * On            : 09 Apr, 2020
 * Description   : ASDS-2497 APU SIT Fixes. Changes to redirect user to default route.
 *
 ******************************************************************************/

import React from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter, Redirect } from "react-router-dom";
import { Grid, Notification } from "@scuf/common";
import Layout from "../Layout/Layout";
import RouteConstants from "../constants/route-constants";
import { ContactUsMessage } from "./ContactUsMessage";

interface IErrorState {
  redirectUser: boolean;
}

class ErrorPage extends React.Component<RouteComponentProps, IErrorState> {
  constructor(props) {
    super(props);
    this.showPurchaseSoftware = this.showPurchaseSoftware.bind(this);
    this.state = {
      redirectUser: false
    };
  }

  showPurchaseSoftware() {
    // Reset error info and redirect to Purchase software page
    if (window.location.href.match(RouteConstants.PURCHASE_SOFTWARE)) {
      window.location.reload();
    } else {
      this.setState({
        redirectUser: true
      });
    }
  }

  render() {
    if (this.state.redirectUser) {
      return (<Redirect to={RouteConstants.DEFAULT_ROUTE} />);
    } else {
      return (
        <Layout>
          <Grid.Row>
            <Grid.Column width={12} className="fullwidthRow">
              <Grid.Row>
                <Grid.Column width={12}>
                  <Notification
                    severity="critical"
                    hasIcon={true}
                    title="There is an error in processing your request."
                    detailsText={window.location.href.match(RouteConstants.PURCHASE_SOFTWARE) ? 'Back to Product Listing' : 'Retry'}
                    onDetailsClick={this.showPurchaseSoftware}
                  >
                    <b>Oops, Something went wrong.</b>
                    <br />
                    <br />
                    <div>
                      <ContactUsMessage >
                        The server encountered an internal error or misconfiguration and was unable to complete your request.
                      <br />
                      Please try again after sometime. If the issue persists,
                    </ContactUsMessage>
                    </div>
                  </Notification>
                </Grid.Column>
              </Grid.Row>
            </Grid.Column>
          </Grid.Row>
        </Layout>
      );
    }
  }
}

function mapStateToProps() {
  console.log('No mapStateToProps');
}

const mapDispatchToProps = {};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ErrorPage)
);
